<template>
  <q-page class="flex column page-layout game-assets" v-if="link">
    <DropboxEmbed :url="link" />
  </q-page>
</template>

<script>
import DropboxEmbed from "@/components/other/DropboxEmbed.vue";

export default {
  name: "GenericDropBox",

  components: {
    DropboxEmbed,
  },

  computed: {
    link() {
      const name = this.$route.meta.name || this.$route.name;

      switch (name) {
        case "game-logos":
          return this.$store.state.content.gamesLogoDropboxPath;
        case "game-certs":
          return this.$store.state.content.gamesCertificationsDropboxPath;
        case "restricted-territories":
          return this.$store.state.content.restrictedTerritoriesDropboxPath;
        case "game-masterlist":
          return this.$store.state.content.gamesMasterListDropboxPath;
        default:
          return null;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.game-assets {
  height: calc(100vh - 60px);
}
</style>
